import '../App.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import TeamCard from '../components/TeamCard';
import { allTeams } from '../data/allTeams';

function HomePage () {

    return (
        <div 
        className="mt-3 d-flex flex-column" 
        dir="rtl"
        >
            <h1>ארכיון ליגת הפרנצ'ייז</h1>
            <p className='m-5'>
                ברוכים הבאים, חברי הליגה! אתר זה נועד לשמר את היסטוריית ליגת הפרנצ'ייז ולהציג נתונים מצטברים מכל עונה ועבור כל קבוצה<br/>
                קליק על קבוצה יציג מידע מגוון עליה ועל המנג'ר(ים) שלה
            </p>
            <Container>
      <Row>
      {allTeams.map((team) => (
         <Col md={2} xs={3} key={team.id}>
         <TeamCard team={team} />
       </Col>
      ))}
      </Row>
    </Container>
        </div>
    )
}

export default HomePage;